// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
class _DataCacheHolder {
    constructor() {
        this._dataCache = {};
    }
    getDataCache() {
        return this._dataCache;
    }
    setDataCache(dataCache) {
        this._dataCache = dataCache;
    }
}
export const DataCacheHolder = new _DataCacheHolder();
